export default __webpack_public_path__ + "static/media/SQS.eee0d215.svg";